import React from 'react';

import { useIntl } from 'react-intl';

import { toast } from 'src/hooks/UseToast';
import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { Role } from 'src/features/roles/utils/types';
import { useCreateRole } from 'src/features/roles/api/useCreateRole';
import { rolesMessages } from 'src/features/roles/utils/messages';
import RoleFormModal from 'src/features/roles/components/forms/RoleFormModal';
import { useParking } from 'src/providers/ParkingProvider';
import { LIST_ROLES_RESOURCE } from 'src/features/roles/api/useListRoles';

interface RoleFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedRole?: Role;
    children?: React.ReactNode;
}

function CreateRoleFormModal<TData>({ className, semantics }: RoleFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { parkingId } = useParking();

    const { mutate, isPending } = useCreateRole({
        onSuccess: (success) => {
            void queryClient.invalidateQueries({ queryKey: [LIST_ROLES_RESOURCE] });
            toast({
                title: formatMessage(rolesMessages.createRoleSuccess),
                description: formatMessage(rolesMessages.createRoleSuccessDescription, {
                    entry: success.name,
                }),
            });
        },
    });

    return (
        <RoleFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ parkingId, ...values }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, { entry: semantics?.entryName?.toLowerCase() })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(rolesMessages.addRoleSubtitle)}
        />
    );
}

export default CreateRoleFormModal;
